import { createI18n } from 'vue-i18n'
import de from './de.json'
import en from './en.json'

export type AppLocale = 'de' | 'en'

export const i18n = createI18n<false>({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  messages: { de, en },
})

export function setAppLocale(loc: AppLocale) {
  i18n.global.locale.value = loc
}
